export default __webpack_public_path__ + "static/media/mybody.628acd0e.jpg";